import React, { useContext } from "react";
import { useCitationsResults } from "./CitationsResults.hook";
import { CitationCard } from "./CitationCard";
import { ConfigStateContext } from "../../../../Contexts/Configurations/context";

interface CitationsResultsProps {
    placement?: "inline" | "footer";
}

const WRAPPER_STYLE: React.CSSProperties = {
    marginBottom: "0",
    width: "100%",
    flex: "0 0 100%",
};

export const CitationsResults: React.FC<CitationsResultsProps> = ({
    placement = "inline",
}) => {
    const { country_code } = useContext(ConfigStateContext);
    const { loading, data, error, hasCitations, hasStructuredFormat } = useCitationsResults();

    const isUyStructured = country_code === "UY" && hasStructuredFormat;

    const showCitation =
        !loading &&
        !!data &&
        hasCitations &&
        // Sólo se oculta por error cuando no hay data usable
        !(error && !data?.html_description) &&
        (placement === "footer" ? isUyStructured : !isUyStructured);

    // El wrapper se renderiza SIEMPRE, incluso vacío (INF-263). Este componente es un hijo
    // condicional en medio de la lista de resultados (Listings.tsx), y si el nodo aparece o
    // desaparece entre el HTML del servidor y el primer render del cliente, React 16 no
    // re-renderiza: mal-parchea la lista de hermanos y termina metiendo la propiedad siguiente
    // dentro de esta card. Manteniendo el nodo, eso no puede pasar.
    //
    // El estilo es CONSTANTE y el ocultado sale de `.citation-slot:empty` (CitationCard.less)
    // a propósito: al hidratar, React 16 sólo parchea el contenido de texto — un `style` que
    // no coincide con el del servidor no se aplica nunca (`diffHydratedProperties` sólo asigna
    // `updatePayload` para CHILDREN). Con un `display` condicional acá, el div se quedaría con
    // el estilo del servidor y dejaría un hueco de un gap en la grilla. Derivándolo del
    // contenido, el ocultado es correcto en las dos direcciones sin depender de React.
    return (
        <div className="citation-slot" style={WRAPPER_STYLE}>
            {showCitation && (
                <CitationCard
                    citation={data}
                    variant={placement === "footer" ? "guide" : "default"}
                />
            )}
        </div>
    );
};
